var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"white"}},[(_vm.isLoggedIn && !_vm.isLoginPageComputed)?_c('app-header'):_vm._e(),_c('v-main',[(_vm.authInitialized || _vm.isLoginPageComputed)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }